import { createSelector } from "reselect";
import { path, prop, identity } from "ramda";

// Selectors
const getAnnotations = path(["domain", "ui", "annotations"]);
export const selectAnnotations = createSelector(getAnnotations, identity);
export const selectIsAnnotationsVisible = createSelector(
  getAnnotations,
  prop("isVisible")
);

// Initial State
const initialState = () => ({
  isVisible: true
});

// Reducer
export default function reducer(state = initialState(), action = {}) {
  switch (action.type) {
    default:
      return state;
  }
}
